import React from "react";
import {
  Button,
  Chip,
  Divider,
  HeaderCard,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  InvoicesHeader,
  KeyValue,
  Modal,
  TableAdv,
} from "../../../../../components";
import { formatCurrency } from "../../../../../utils/stringUtils";
import { dateFormator } from "../../../../../utils";
import dayjs from "dayjs";
import common from "../../../../../utils/common";

const ProceedInvoice = ({
  isOpen,
  onClose,
  onSave,
  onSubmit,
  data,
  totalDue,
  mappedRows,
  columns,
  tableSubTotal,
}) => {
  const { calculateTotalDiscountInvoice, calculateDiscountedTotal } = common;
  // console.log("data in procedd view", { data });
  return (
    <Modal
      title={"Proceed Invoice"}
      isOpen={isOpen}
      onClose={onClose}
      width="max-w-full"
    >
      <div className="flex flex-col gap-5">
        <div className="inputShadow p-3 pt-0 flex flex-col gap-1">
          <div className="flex justify-between items-center">
            <div>
              <InvoicesHeader
                data={{
                  // logo: companyLogo,
                  title: "Tektree",
                  invoiceNumber: (
                    <span
                      style={{
                        background: "rgba(255, 190, 0, 0.2)",
                        padding: "2px 4px",
                        borderRadius: "4px",
                      }}
                    >
                      {data?.invoiceNumber}
                    </span>
                  ),
                  invoiceStatus: "Saving",
                }}
              />
            </div>
            <div className="min-w-60">
              {/* <InfoTimeCardAdv
                title="Total Due"
                value={totalDue}
                prefix=""
                suffix="USD"
                color="primary"
                size="xs-sm"
              /> */}
              <InfoCardNewAdv
                layout="option12"
                title="Total Due"
                value={totalDue}
                valueConfig={{className:"text-[24px]!"}}
                suffixConfig={{className:"mt-1 justify-end! item-end! font-normal!"}}
                suffix="USD"
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <HeaderCard
            title={"Bill To"}
            className="!bg-primary-50 !text-primary"
          >
            <div>
              {data?.billingAddress?.split("\n")?.map((data, index) => (
                <p key={index} className={index === 0 ? "font-medium" : ""}>{data}</p>
              ))}
            </div>
          </HeaderCard>

          <HeaderCard
            title={"Invoice Details"}
            className="!bg-primary-50 !text-primary"
          >
            <div className="flex flex-col gap-1">
              <KeyValue
                label={"Invoice"}
                value={
                  <span
                    className="text-bold"
                    style={{
                      backgroundColor: "rgba(255, 190, 0, 0.2)",
                      padding: "2px 4px",
                      borderRadius: "4px",
                    }}
                  >
                    {data?.invoiceNumber}
                  </span>
                }
              />
              <KeyValue
                label="Invoice Date"
                value={data?.invoiceDate ? dateFormator(data?.invoiceDate) : ""}
              />
              <KeyValue
                label={"Shipped Date"}
                value={data?.shippedDate ? dateFormator(data?.shippedDate) : ""}
              />
              <KeyValue
                label={"Due Date"}
                value={
                  data?.dueDate instanceof Date
                    ? dateFormator(data?.dueDate)
                    : dayjs(data?.dueDate).format("MM/DD/YYYY")
                }
              />
              {/* <KeyValue label={"Class"} value={"Sukumar Mididodi"} /> */}
              <KeyValue
                label={"Terms"}
                value={data?.netTerms?.value ?? data?.netTerms}
              />
            </div>
          </HeaderCard>
        </div>

        <div className="inputShadow p-3 w-full">
          <div className="shadow-md">
            <TableAdv
              rows={mappedRows}
              columns={columns}
              hideToolBar
              showSlNo
            />
          </div>
          <div className="flex justify-end ">
            <div className="my-2 grid grid-cols-[1fr_190px] gap-x-10 w-fit max-w-2xl text-sm ">
              <div className="py-2 font-medium">Subtotal</div>
              <div className="py-2 font-medium">
                {formatCurrency(tableSubTotal)}
              </div>
              <div className="col-span-2 border-t border-gray-200" />
              {(data?.discounts?.length > 0 && data?.discounts?.filter((d)=>Number(d.value))?.filter(Boolean)?.length > 0) && (
                <>
                  {data?.discounts
                    .map((discount, index) => (
                      <React.Fragment key={discount?.id || index}>
                        <div className="py-2">{discount?.name}</div>
                        <div className="py-2">
                          {discount?.type === 1
                            ? `-${formatCurrency(
                                Math.round(
                                  Number(tableSubTotal) * Number(discount?.value)
                                ) / 100
                              )}`
                            : `-${formatCurrency(Number(discount?.value))}`}
                        </div>
                        <div className="col-span-2 border-t border-gray-200" />
                      </React.Fragment>
                    ))
                    .reverse()}
                </>
              )}
              <div className="col-span-2 border-t border-gray-200" />
              {(data?.discounts?.length > 0 && data?.discounts?.filter((d)=>Number(d.value))?.filter(Boolean)?.length > 0) && (
                <>
                  <div className="py-2 font-medium">Discount Total</div>
                  <div className="py-2 font-medium">
                    {formatCurrency(
                      calculateTotalDiscountInvoice(
                        data?.discounts,
                        tableSubTotal
                      )
                    )}
                  </div>
                  <div className="col-span-2 border-t border-gray-200" />
                </>
              )}
              <div className="py-2 font-medium">Invoice Total</div>
              <div className="py-2 font-medium">
                {formatCurrency(
                  calculateDiscountedTotal(tableSubTotal, data?.discounts)
                )}
              </div>
              <div className="col-span-2 border-t border-gray-200" />
            </div>
          </div>
        </div>
        {/* ///////////////////////////////////////////////////////////////////////////////////// */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div className="inputShadow p-3 flex flex-col gap-2">
            <KeyValue
              label={"Statement Memo"}
              className="text-primary"
              value={data?.statementMemo}
            />

            <KeyValue
              label={"Statement Memo Period"}
              className="text-primary"
              value={`${dayjs(data?.statementMemoFromTo?.from).format(
                "MM/DD/YYYY"
              )} - ${dayjs(data?.statementMemoFromTo?.to).format(
                "MM/DD/YYYY"
              )}`}
            />
          </div>
          <div className="inputShadow p-3 flex justify-between items-center">
            <div>
              <Chip
                label={`Attachments:-0`}
                variant="text"
                color="black"
                icon={"attach_file"}
                disabled
                iconPosition={"before"}
              />
            </div>
            <div>
              <Button size="xs-sm" title={"Add Attachment"} />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 items-end gap-5">
          <div className="w-fit min-w-[360px]">
            <div className="border-[1px] border-neutrals-50 rounded-sm px-3 py-2 ">
              <h6 className="font-medium ">Additional Info</h6>
              <Divider />
              {data?.additionalInfo}
            </div>
          </div>

          <div className="flex-1 flex justify-end gap-2">
            <Button
              title={"Cancel"}
              size="sm"
              variant="outlined"
              onClick={onClose}
            />
            <Button
              title={"Save"}
              size="sm"
              variant="outlined"
              onClick={onSave}
            />
            <Button title={"Submit"} size="sm" onClick={onSubmit} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProceedInvoice;
